import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";


export default class EditMessage extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "editMessage";
    }

    public receive(payload: CometOperatorApplication.EditMessageCometMessageOpenApiModel): void {
        ClientUserdataStore.addMessage({message: payload.message, replaceOnly: true});
    }

}